/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Available_DocumentsInputs */

const en_available_documents = /** @type {(inputs: Available_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available Documents`)
};

const id_available_documents = /** @type {(inputs: Available_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen Tersedia`)
};

/** @type {(inputs: Available_DocumentsInputs) => LocalizedString} */
const es_available_documents = en_available_documents;

/** @type {(inputs: Available_DocumentsInputs) => LocalizedString} */
const fr_available_documents = en_available_documents;

/** @type {(inputs: Available_DocumentsInputs) => LocalizedString} */
const de_available_documents = en_available_documents;

/** @type {(inputs: Available_DocumentsInputs) => LocalizedString} */
const ja_available_documents = en_available_documents;

/** @type {(inputs: Available_DocumentsInputs) => LocalizedString} */
const zh_available_documents = en_available_documents;

/** @type {(inputs: Available_DocumentsInputs) => LocalizedString} */
const ar_available_documents = en_available_documents;

/** @type {(inputs: Available_DocumentsInputs) => LocalizedString} */
const it_available_documents = en_available_documents;

/** @type {(inputs: Available_DocumentsInputs) => LocalizedString} */
const ru_available_documents = en_available_documents;

/** @type {(inputs: Available_DocumentsInputs) => LocalizedString} */
const pt_available_documents = en_available_documents;

/** @type {(inputs: Available_DocumentsInputs) => LocalizedString} */
const ko_available_documents = en_available_documents;

/**
* | output |
* | --- |
* | "Available Documents" |
*
* @param {Available_DocumentsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const available_documents = /** @type {((inputs?: Available_DocumentsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Available_DocumentsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_available_documents(inputs)
	if (locale === "es") return es_available_documents(inputs)
	if (locale === "fr") return fr_available_documents(inputs)
	if (locale === "de") return de_available_documents(inputs)
	if (locale === "ja") return ja_available_documents(inputs)
	if (locale === "zh") return zh_available_documents(inputs)
	if (locale === "ar") return ar_available_documents(inputs)
	if (locale === "id") return id_available_documents(inputs)
	if (locale === "it") return it_available_documents(inputs)
	if (locale === "ru") return ru_available_documents(inputs)
	if (locale === "pt") return pt_available_documents(inputs)
	return ko_available_documents(inputs)
});